import { api } from '@/shared/api'
import { playerAuth } from '@/shared/game/api'
import type { ChatKind, ChatMessage, Phrase } from './types'

/**
 * Словарь фраз.
 *
 * Приходит с сервера, а не лежит здесь списком: коды уезжают в базу, и два
 * списка разошлись бы на первой же правке формулировки. Заодно у мобильного
 * приложения (docs/MOBILE.md) остаётся право нарисовать ту же фразу своими
 * словами — общее у нас только код.
 */
export async function fetchPhrases(): Promise<Phrase[]> {
  const { data } = await api.get<{ phrases: Phrase[] }>('/chat/phrases')

  return data.phrases ?? []
}

/**
 * Разговор: хвост или пропущенное.
 *
 * `after` — номер последней виденной реплики. Догон обязателен, а не «на
 * всякий случай»: у канала нет истории, и пока сокет лежал, разговор ушёл
 * вперёд — задним числом события не приходят.
 */
export async function fetchMessages(gameId: string, after?: number): Promise<ChatMessage[]> {
  const { data } = await api.get<{ messages: ChatMessage[] }>(`/games/${gameId}/messages`, {
    params: after === undefined ? undefined : { after },
    headers: playerAuth(gameId),
  })

  return data.messages ?? []
}

/**
 * Сказать что-нибудь.
 *
 * Свободный текст сервер принимает только за закрытым столом: за открытым,
 * который раздаёт быстрая игра случайным людям, говорить можно лишь готовым
 * (App\Services\Chat\ChatService::write). Интерфейс поля ввода там просто не
 * показывает, но правило держит сервер.
 */
export async function postMessage(
  gameId: string,
  kind: ChatKind,
  body: string,
): Promise<ChatMessage> {
  const { data } = await api.post<ChatMessage>(
    `/games/${gameId}/messages`,
    { kind, body },
    { headers: playerAuth(gameId) },
  )

  return data
}
